import React, {useId} from 'react';

export type ProvenExpertStar = {
  fill: number; // from 0 to 1 in decimal, where 0 is 0% and 1 is 100%
  color?: string;
  stopColor?: string;
  height?: string;
  width?: string;
};

export const ProvenExpertStar = ({fill, color = '#EAA519', height = '33', width = '31', stopColor = 'transparent'}: ProvenExpertStar) => {
  const uniqueDefsId = useId();

  return (
    <svg width={width} height={height} viewBox='0 0 34 33' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        {fill === 1 ? (
          <linearGradient id={`${uniqueDefsId}-full`}>
            <stop offset='0%' stopColor={color} />
            <stop offset='50%' stopColor={color} />
            <stop offset='50%' stopColor={color} />
            <stop offset='100%' stopColor={color} />
          </linearGradient>
        ) : (
          <linearGradient id={`${uniqueDefsId}-custom`}>
            <stop offset='0%' stopColor={color} />
            <stop offset={`${fill * 100}%`} stopColor={color} />
            <stop offset={`${fill * 100}%`} stopColor={stopColor} />
            <stop offset='100%' stopColor={stopColor} />
          </linearGradient>
        )}
      </defs>
      <path
        d='M16.8198 1.5L21.6575 11.4466L32.6466 12.9593L24.6488 20.619L26.6008 31.5L16.8198 26.2862L7.03745 31.5L8.99075 20.619L0.992905 12.9593L11.982 11.4466L16.8198 1.5Z'
        stroke={color}
        fill={`url(#${uniqueDefsId}${fill === 1 ? '-full' : '-custom'})`}
        strokeWidth='1'
      />
    </svg>
  );
};
